module.exports = __webpack_public_path__ + "static/media/2 (3).ebfb9d42.JPG";